import { useCart } from '../hooks/useCart';
import { useLang } from '../hooks/useLanguage';

export default function SidebarSeats() {
    const { seats } = useCart();
    const { getI18n } = useLang();

    return (
        seats &&
        seats.length > 0 && (
            <ul>
                {seats.map((seat) => (
                    <li key={seat.id}>
                        {getI18n(seat.name, seat.nameI18n)} -{' '}
                        {getI18n(seat.ticketTypeName, seat.ticketTypeNameI18n)}
                    </li>
                ))}
            </ul>
        )
    );
}
